export default __webpack_public_path__ + "static/media/sideNavTop.4a7c6304.png";